import { render } from "./DynamicDivider.vue?vue&type=template&id=de74ce9c&ts=true"
import script from "./DynamicDivider.vue?vue&type=script&lang=ts"
export * from "./DynamicDivider.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicDivider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "de74ce9c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('de74ce9c', __exports__)) {
    api.reload('de74ce9c', __exports__)
  }
  
  module.hot.accept("./DynamicDivider.vue?vue&type=template&id=de74ce9c&ts=true", () => {
    api.rerender('de74ce9c', render)
  })

}


export default __exports__